import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4011';

export interface CreateReportDto {
  reportedId: string;
  reason: string;
  details?: string;
}

export interface ReportResponse {
  success: boolean;
  message: string;
  reportId: string;
}

export class ReportsService {
  /**
   * Submit a report
   */
  static async createReport(
    accessToken: string,
    reportedId: string,
    reason: string,
    details?: string,
  ): Promise<ReportResponse> {
    const response = await axios.post(
      `${API_URL}/reports`,
      {
        reportedId,
        reason,
        details,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  }

  /**
   * Get available report reasons
   */
  static async getReportReasons(accessToken: string): Promise<string[]> {
    const response = await axios.get(`${API_URL}/reports/reasons`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data.reasons;
  }
}

export default ReportsService;
